import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import CloseIcon from '@assets/icons/close.svg?react';

export default function Modal({ children, show = false, maxWidth = '2xl', withCloseButton = false, insetCloseButton = false, closeable = true, onClose = () => {} }) {
    const close = () => {
        if (closeable) {
            onClose();
        }
    };

    const maxWidthClass = {
        sm: 'sm:max-w-sm',
        md: 'sm:max-w-md',
        lg: 'sm:max-w-lg',
        xl: 'sm:max-w-xl',
        '2xl': 'sm:max-w-2xl',
        '4xl': 'sm:max-w-4xl',
        '5xl': 'sm:max-w-5xl',
        '6xl': 'sm:max-w-6xl',
    }[maxWidth];

    return (
        <Transition show={show} as={Fragment} leave="duration-200">
            <Dialog
                as="div"
                id="modal"
                className="modal-dialog fixed inset-0 flex flex-wrap justify-center overflow-y-auto sm:px-4 xl:px-0 py-24 items-center z-[500] transform transition-all warm-shadow"
                onClose={close}
            >
                {withCloseButton && !insetCloseButton && (
                    <div
                        className="flex absolute top-6 right-6 md:top-8 md:right-10 rounded-full p-4 cursor-pointer bg-smooth-gray transition text-light-gray hover:text-white"
                        onClick={close}
                    >
                        <CloseIcon className="size-5" />
                    </div>
                )}

                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 -translate-y-4 scale-75"
                    enterTo="opacity-100 translate-y-0 scale-100"
                    leave="ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0 scale-100"
                    leaveTo="opacity-0 -translate-y-2 scale-90"
                >
                    <Dialog.Panel
                        className={`dark:bg-dark-gray bg-white rounded-md shadow-xl transform transition-all w-full sm:mx-auto relative ${maxWidthClass}`}
                    >
                        {withCloseButton && insetCloseButton && (
                            <div
                                className="absolute z-10 top-2.5 sm:-top-5 right-2 sm:-right-5 rounded-full p-2.5 sm:p-4 cursor-pointer bg-black dark:bg-white text-white dark:text-black transition hover:text-white dark:hover:text-black"
                                onClick={close}
                            >
                                <CloseIcon className="size-5"/>
                            </div>
                        )}
                        {children}
                    </Dialog.Panel>
                </Transition.Child>
            </Dialog>
        </Transition>
    );
}
